import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { API_ServerAddress } from 'src/app/MyAppCommonConfig';

declare var $: any;

@Injectable()
export class themservice {

    constructor(private http: HttpClient) {
        this.selectthem();
    }
    SelectedTemId: number = 0;
    changeCSS(link) {



        var newlink = document.createElement("link");
        newlink.setAttribute("rel", "stylesheet");
        newlink.setAttribute("type", "text/css");
        newlink.setAttribute("href", link);
        $("head").append(newlink);


    }
    selectthem() {
        this.http.get(API_ServerAddress+`api/Them/GetSelectedthem/`).subscribe((resp: any) => {

            this.SelectedTemId = resp;

            switch (resp) {
                case 1:
                    this.changeCSS("assets/css/tooplate-style.css");
                    this.changeCSS("assets/css/bootstrap.min.css");
                   
                    break;
                case 2:
                    this.changeCSS("assets/css/lab.css");
                    this.changeCSS("https://cdnjs.cloudflare.com/ajax/libs/font-awesome/4.7.0/css/font-awesome.min.css");
                    this.changeCSS("https://maxcdn.bootstrapcdn.com/bootstrap/3.3.7/css/bootstrap.min.css");
                    break;
                    case 3:
                        this.changeCSS("assets/media/template/mainstyle-7b96a9cf.css");
                        this.changeCSS("assets/media/template/theme-f85a6f13.css");
                        this.changeCSS("https://cdnjs.cloudflare.com/ajax/libs/font-awesome/4.7.0/css/font-awesome.min.css");
                        this.changeCSS("assets/RTLbootstrap/css/bootstrap-rtl.css");
                        break; 
                        case 4:
                            this.changeCSS("/assets/theme4/site.css");
                            this.changeCSS("assets/RTLbootstrap/css/bootstrap-rtl.css");
                            this.changeCSS("https://cdnjs.cloudflare.com/ajax/libs/font-awesome/4.7.0/css/font-awesome.min.css");
                            this.changeCSS("https://maxcdn.bootstrapcdn.com/bootstrap/3.3.7/css/bootstrap.min.css");
                            break; 

            }

        }, err => { console.error(err) });
    }
}